export default class Forms {
  constructor() {
    this.getElems()
    this.events()
  }

  getElems() {
    this.forms = Array.from(document.querySelectorAll('form:not(#ajax-search-form):not(.jobs-search-form)'))
  }

  events() {
    if (this.forms) {
      this.forms.forEach((form) => {
        const fields = Array.from(form.querySelectorAll('input, textarea'))

        if (fields) {
          fields.forEach((field) => {
            field.addEventListener('input', () => {
              this._checkFieldValue(field)
            })
          })
        }
      })
    }
  }

  _checkFieldValue(field) {
    const label = field.parentNode.querySelector('label') || field.parentNode.parentNode.querySelector('label')

    if (field.value.trim() === '') {
      field.classList.remove('--has-value')
      label.classList.remove('--has-value')
    } else {
      field.classList.add('--has-value')
      label.classList.add('--has-value')
    }
  }
}
